"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsAttributeListRow = exports.LIST_ITEM_HEIGHT = void 0;
const react_1 = __importStar(require("react"));
const product_details_attribute_component_1 = require("./product-details-attribute/product-details-attribute.component");
const product_details_attribute_styles_1 = require("./product-details-attribute/product-details-attribute.styles");
const context_1 = require("../../../context");
exports.LIST_ITEM_HEIGHT = 100;
const ProductDetailsAttributeListRow = ({ index, style, data }) => {
    const rowRef = (0, react_1.useRef)(null);
    const { isNodeReEnriching } = (0, context_1.useCatalogActivityProgressContext)();
    const { items, setSize, isLocked } = data, itemProps = __rest(data, ["items", "setSize", "isLocked"]);
    const item = items[index];
    const { label, isEditable, selectedValues } = item;
    const isDisabledByReEnrich = (0, react_1.useMemo)(() => isLocked || isNodeReEnriching(itemProps.productTreeNodeId), [isLocked, isNodeReEnriching, itemProps.productTreeNodeId]);
    (0, react_1.useEffect)(() => {
        const { height } = rowRef.current.getBoundingClientRect();
        setSize(index, Math.max(height, exports.LIST_ITEM_HEIGHT));
    }, [setSize, index, item]);
    return (react_1.default.createElement("div", { style: style }, react_1.default.createElement(product_details_attribute_styles_1.StyledAttributeWrapper, { ref: rowRef }, react_1.default.createElement(product_details_attribute_component_1.ProductDetailsAttribute, Object.assign({ label: label, disabled: !isEditable || isDisabledByReEnrich, selectedValues: selectedValues }, itemProps)))));
};
exports.ProductDetailsAttributeListRow = ProductDetailsAttributeListRow;
